"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCommandsPartition = exports.zen2han = exports.calcString = exports.rgb2hex = exports.hsl2rgb = exports.string2Int = exports.unescapeHtml = void 0;
function unescapeHtml(target) {
    if (typeof target !== 'string')
        return target;
    const patterns = {
        '&lt;': '<',
        '&gt;': '>',
        '&amp;': '&',
        '&quot;': '"',
        '&#x27;': '\'',
        '&#x60;': '`'
    };
    return target.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, (match) => patterns[match]);
}
exports.unescapeHtml = unescapeHtml;
;
function string2Int(str) {
    return !!str ? parseInt(str) : 0;
}
exports.string2Int = string2Int;
/**
 * HSLからRGBを算出して返却
 * @param  {number} h - 色相 (0~360)
 * @param  {number} s - 彩度 (0~100)
 * @param  {number} l - 明度 (0~100)
 * @return {colorRGB} r: 赤 (0~255), g: 緑 (0~255), b: 青 (0~255)
 */
const hsl2rgb = function (h, s, l) {
    const RGB_MAX = 255;
    const HUE_MAX = 360;
    const SATURATION_MAX = 100;
    const LIGHTNESS_MAX = 100;
    let r, g, b, max, min;
    h = h % HUE_MAX;
    s = s / SATURATION_MAX;
    l = l / LIGHTNESS_MAX;
    if (l < 0.5) {
        max = l + l * s;
        min = l - l * s;
    }
    else {
        max = l + (1 - l) * s;
        min = l - (1 - l) * s;
    }
    const hp = HUE_MAX / 6;
    const q = h / hp;
    if (q <= 1) {
        r = max;
        g = (h / hp) * (max - min) + min;
        b = min;
    }
    else if (q <= 2) {
        r = ((hp * 2 - h) / hp) * (max - min) + min;
        g = max;
        b = min;
    }
    else if (q <= 3) {
        r = min;
        g = max;
        b = ((h - hp * 2) / hp) * (max - min) + min;
    }
    else if (q <= 4) {
        r = min;
        g = ((hp * 4 - h) / hp) * (max - min) + min;
        b = max;
    }
    else if (q <= 5) {
        r = ((h - hp * 4) / hp) * (max - min) + min;
        g = min;
        b = max;
    }
    else {
        r = max;
        g = min;
        b = ((HUE_MAX - h) / hp) * (max - min) + min;
    }
    return {
        r: Math.round(r * RGB_MAX),
        g: Math.round(g * RGB_MAX),
        b: Math.round(b * RGB_MAX),
    };
};
exports.hsl2rgb = hsl2rgb;
function rgb2hex(rgb) {
    let rHex = rgb.r.toString(16);
    let gHex = rgb.g.toString(16);
    let bHex = rgb.b.toString(16);
    rHex = rHex.length === 1 ? '0' + rHex : rHex;
    gHex = gHex.length === 1 ? '0' + gHex : gHex;
    bHex = bHex.length === 1 ? '0' + bHex : bHex;
    return `#${rHex}${gHex}${bHex}`;
}
exports.rgb2hex = rgb2hex;
function calcString(str) {
    if (str.match(/[^0-9\+\-\*\/~\(\)]/g) === null) {
        if (str === '')
            return 0;
        const number = new Function(`"use strict"; return (${str});`)();
        return parseInt(number);
    }
    return NaN;
}
exports.calcString = calcString;
function zen2han(str) {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
        .replace(/＋/g, '+')
        // .replace(/ー/g, '-')
        .replace(/＞/g, '>')
        .replace(/／/g, '/')
        .replace(/（/g, '(')
        .replace(/）/g, ')');
}
exports.zen2han = zen2han;
function generateCommandsPartition(description) {
    const partitionArray = [];
    let hyphenNum = 55 - description.length * 4;
    if (hyphenNum < 0)
        return `■${description}■`;
    const hyphenHalfArray = [];
    for (let i = 0; i < hyphenNum / 2; i++) {
        hyphenHalfArray.push(`-`);
    }
    const hyphenHalf = hyphenHalfArray.join(``);
    return `■${hyphenHalf}${description}${hyphenHalf}■`;
}
exports.generateCommandsPartition = generateCommandsPartition;
//# sourceMappingURL=util.js.map